// extracted by mini-css-extract-plugin
export default {"range":"_range_gZKmdw","labels":"_labels_gmYFW3","min":"_min_Qj2ExT","max":"_max_ledJQv"};